import type { Diagnosis } from '@seen/core/models/conditions/Diagnosis'
import { extractTextFromHTML } from '#src/utils/html.ts'

// The plain-text narrative to show under a condition's `name`, or undefined
// when it adds nothing. `name` prefers `code.text`, which can go stale when an
// Elation sync overwrites the coding/narrative but not `code.text` (or vice
// versa), so surfacing the diverging narrative keeps the condition legible.
// The narrative is `text.div`, which may be XHTML, so it is reduced to plain
// text here (React owns the DOM dependency; `@seen/core` stays DOM-free) before
// both the echo comparison and display.
export function conditionSecondaryName(
  condition: Diagnosis
): string | undefined {
  if (condition.code?.text === undefined) {
    // `name` already resolves to the narrative; nothing distinct to add.
    return undefined
  }
  const narrative = extractTextFromHTML(condition.title).trim()
  if (!narrative || narrative === 'New Problem') {
    return undefined
  }
  if (narrative.toLowerCase() === condition.name.trim().toLowerCase()) {
    return undefined
  }
  return narrative
}
